//Template.js
///////////////////////////////
//React & Material
import React from 'react';

//Plugins
import styled from 'styled-components';
import {Image } from 'react-bootstrap';
import Heart from '../media/heart1.svg';
//Component Imports

//////////////////////////////
//Styled components

const FooterWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 70px 60px;
  // white-space: nowrap;
`

const FooterText = styled.h2`
  font-weight: bold;
  /* identical to box height */

  letter-spacing: -0.065em;

  color: #FFFFFF;
`
const HeartEmoji = styled.span`
  margin-right:5px;
  margin-left:5px;
  color :#36FFC1;

  // max-width:40px;

`
const HeartI = styled(Image)`

padding-bottom:5px;
`
//////////////////////////////
//Component class
/**
 * Displays a template component
 */
function Footer(props) {

  return (
  <FooterWrapper>
   <FooterText>Made with <HeartEmoji><HeartI fluid src={Heart}/></HeartEmoji> in Melbourne with React</FooterText>
  </FooterWrapper>
  )
}
export default Footer;